module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sgc-1",
    attrs: {
      "id": "dixie"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "dixie1"
    }
  }, [_c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "toc"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Acknowledgments#toc-anchor"
    }
  }, [_vm._v("ACKNOWLEDGEMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Preface#toc-anchor-1"
    }
  }, [_vm._v("Preface — That Window")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter_01#toc-anchor-2"
    }
  }, [_vm._v("Chapter 1 — Rumors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter_02#toc-anchor-3"
    }
  }, [_vm._v("Chapter 2 — Doomed Marriage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter_03#toc-anchor-4"
    }
  }, [_vm._v("Chapter 3 — Early Years")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_04#toc-anchor-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4 — Prince Charming")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_05#toc-anchor-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5 — Fateful Decision")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_06#toc-anchor-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6 — Where’s Scott?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_07#toc-anchor-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7 — The Search Begins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_08#toc-anchor-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8 — The House")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_09#toc-anchor-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9 — The Discovery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_10#toc-anchor-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10 — The Autopsy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_11#toc-anchor-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11 — Dixie’s Arrest")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_12#toc-anchor-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12 — Money Trouble")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_13#toc-anchor-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13 — The Prosecutor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_14#toc-anchor-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14 — Dixie’s Gamble")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_16#toc-anchor-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16 — Cross-Examination")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_17#toc-anchor-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17 — The Shotgun")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_18#toc-anchor-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18 — Missed Opportunity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_19#toc-anchor-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19 — Judgment Day")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_20#toc-anchor-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20 — Dixie’s Next Decade")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_21#toc-anchor-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21 — Denial")])])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre3",
    attrs: {
      "id": "calibre_pb_5"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24614150","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TOC.vue
// module id = 66
// module chunks = 0